import React from 'react';
import { useOrganization } from '../context/OrganizationContext';
import './Footer.css';

const Footer = () => {
  const { organization: councilor } = useOrganization();

  // Get phone numbers as array, filter out empty, N/A, and whitespace values
  const phoneNumbers = councilor?.phone_numbers
    ?.split(',')
    .map(p => p.trim())
    .filter(p => p && p !== 'N/A' && p.toLowerCase() !== 'n/a') || [];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {councilor?.logo && (
            <div className="footer-section">
              <img src={councilor.logo} alt={councilor.chinese_name || '組織'} className="footer-logo" />
            </div>
          )}

          {(councilor?.office_address || phoneNumbers.length > 0 || councilor?.email) && (
            <div className="footer-section">
              <h4>聯絡我們</h4>
              {councilor?.office_address && (
                <p>地址：{councilor.office_address}</p>
              )}
              {phoneNumbers.length > 0 && (
                <p>電話：{phoneNumbers.join(' / ')}</p>
              )}
              {councilor?.email && (
                <p>電郵：{councilor.email}</p>
              )}
            </div>
          )}

          <div className="footer-section">
            <h4>快速連結</h4>
            <ul>
              <li><a href="/about">關於{councilor?.chinese_name || '我們'}</a></li>
              <li><a href="/blog">最新消息</a></li>
              <li><a href="/services">核心服務</a></li>
              <li><a href="/contact">聯絡我們</a></li>
              <li><a href="/organization-structure">組織架構</a></li>
              <li><a href="/page/future-outlook">未來展望</a></li>
              <li><a href="/page/terms">使用條款</a></li>
              <li><a href="/page/privacy">私隱條款</a></li>
            </ul>
          </div>

          {(councilor?.facebook_url || councilor?.instagram_url) && (
            <div className="footer-section">
              <h4>關注我們</h4>
              <div className="social-links">
                {councilor?.facebook_url && (
                  <a href={councilor.facebook_url} target="_blank" rel="noopener noreferrer">Facebook</a>
                )}
                {councilor?.instagram_url && (
                  <a href={councilor.instagram_url} target="_blank" rel="noopener noreferrer">Instagram</a>
                )}
              </div>
            </div>
          )}
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} {councilor?.chinese_name || councilor?.english_name || 'Hong Kong Synergies'} 版權所有</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
